export default __webpack_public_path__ + "static/media/mongodb-icon2.36bc3011.png";